import React from "react";
import CarouselItem from './singleItem/CarouselItem'

/*===IMAGES PROJECT MOCKUPS===*/
import SiproMockup from '../../../assets/carouselProjects/proyectoSIPRO.png'
import DiploMockup from '../../../assets/carouselProjects/proyectoDiplomado.png'
import BioestadisticoMockup from '../../../assets/carouselProjects/bioestadistico.png'
import CemtMockup from '../../../assets/carouselProjects/proyectoCemt.png'
import JoseSupoMockup from '../../../assets/carouselProjects/josesupo.png'
import KinderMockup from '../../../assets/carouselProjects/kinder.png'
import SincieMockup from '../../../assets/carouselProjects/sincie.png'
import SpssMockup from '../../../assets/carouselProjects/proyectoSpss.png'
import TapifMockup from '../../../assets/carouselProjects/proyectoTapif.png'
import BitacoraMockup from '../../../assets/carouselProjects/bitacoraWP.png'
import WikipelisMockup from '../../../assets/carouselProjects/wikipelis.png'
import DigitalcartasMockup from '../../../assets/carouselProjects/digitalcartas.png'
import ElencuentroMockup from '../../../assets/carouselProjects/elencuentro.png'
/*===IMAGES PROJECT LOGOS===*/
import BitacoraLogo from '../../../assets/carouselProjects/bitacoraWP__banner.jpg'
import WikipelisLogo from '../../../assets/carouselProjects/wikipelisBanner.jpg'
import DigitalcartasLogo from '../../../assets/carouselProjects/digitalcartasBanner.jpg'
import ElencuentroLogo from '../../../assets/carouselProjects/elencuentroBanner.jpg'
import SiproLogo from '../../../assets/carouselProjects/sipro__banner.jpg'
import DiploLogo from '../../../assets/carouselProjects/diplo__banner.jpg'
import BioestadisticoLogo from '../../../assets/carouselProjects/bioestadistico__banner.jpg'
import CarlSaganLogo from '../../../assets/carouselProjects/carlSagan__banner.jpg'
import CemtLogo from '../../../assets/carouselProjects/cemt__banner.jpg'
import JoseSupoLogo from '../../../assets/carouselProjects/joseSupo__banner.jpg'
import SincieLogo from '../../../assets/carouselProjects/sincie__banner.jpg'
import SpssLogo from '../../../assets/carouselProjects/spss__banner.jpg'
import TapifLogo from '../../../assets/carouselProjects/tapif__banner.jpg'

const carousel =[
    //<CarouselItem logo={BitacoraLogo}  mockup={BitacoraMockup} link={'https://bitacorawp.com/'}/>,
    <CarouselItem logo={WikipelisLogo}  mockup={WikipelisMockup} link={'https://pablofcc97.github.io/wikipelis/'}/>,
    <CarouselItem logo={DigitalcartasLogo}  mockup={DigitalcartasMockup} link={'https://digitalcartas.com/'}/>,
    <CarouselItem logo={ElencuentroLogo}  mockup={ElencuentroMockup} link={'https://elencuentro.digitalcartas.com/'}/>,
    <CarouselItem logo={SiproLogo}  mockup={SiproMockup} link={'https://seminariosdeinvestigacion.com/3-0'}/>,
    <CarouselItem logo={DiploLogo}  mockup={DiploMockup} link={'https://diplomadoeninvestigacion.com/'}/>,
    <CarouselItem logo={BioestadisticoLogo}  mockup={BioestadisticoMockup} link={'https://bioestadistico.com/'}/>,
    <CarouselItem logo={CemtLogo}  mockup={CemtMockup}  link={'https://comoempezarunatesis.com/'}/>,
    <CarouselItem logo={JoseSupoLogo}  mockup={JoseSupoMockup} link={'https://josesupo.com/'}/>,
    <CarouselItem logo={CarlSaganLogo}  mockup={KinderMockup}  link={'https://carlsagankinder.com/'}/>,
    <CarouselItem logo={SincieLogo}  mockup={SincieMockup}  link={'https://sincie.com/'}/>,
    <CarouselItem logo={SpssLogo}  mockup={SpssMockup} link={'https://cursodespss.com/'}/>,
    <CarouselItem logo={TapifLogo}  mockup={TapifMockup} link={'https://tallerdetesis.com/carta/'}/>
]


export default carousel 